export default __webpack_public_path__ + "static/media/cover3.f67937a5.jpg";